<template>
  <div>
    <Tabs :tabIndex="tabIndex"/>
    <b-container>
      <b-row>
        <b-col cols="12" lg="3" class="mypage__sidebar">
          <SidebarVendor />
        </b-col>
        <b-col cols="12" lg="9" class="pl-70">
          <form action="">
            <label for="" class="admin-vendor-label">所在地</label>
            <b-row>
              <b-col cols="12" lg="6">
                <b-row>
                  <b-col cols="5" class="pr-0 input-group">
                    <input type="text" name="" id="" class="input-form" placeholder="100" v-model="zip_code_1" :class="zipCodeHeadFormat()" @input="$v.zip_code_1.$touch()">
                    <small v-if="(!$v.zip_code_1.numeric || !$v.zip_code_1.valid) && ((zip_code_1 !== '') || (zip_code_2 !== ''))" class="text-input error">{{message.ZIPCODE_HEAD_FORMAT}}</small>
                  </b-col>
                  <b-col cols="2" class="d-flex justify-content-center align-content-center"><span class="admin-vendor-spaceIP"></span></b-col>
                  <b-col cols="5" class="pl-0 input-group">
                    <input type="text" name="" id="" class="input-form" placeholder="0001" v-model="zip_code_2" :class="zipCodeTailFormat()" @input="$v.zip_code_2.$touch()">
                    <small v-if="(!$v.zip_code_2.numeric || !$v.zip_code_2.valid) && ((zip_code_2 !== '') || (zip_code_1 !== ''))" class="text-input error">{{message.ZIPCODE_TAIL_FORMAT}}</small>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" lg="6" class="mt-20">
                <b-form-input type="text" autocomplete="off" list="places" class="input-form" placeholder="所在地を入力してください" v-model="detailCompany.address" />
                <datalist id="places">
                  <option v-for="(place, index) in searchResults" @click="selectedOption(place)" :value="place" v-text="place" :key="index"></option>
                </datalist>
              </b-col>
            </b-row>
            <div class="form-group">
              <label for="" class="admin-vendor-label">会社名<span class="required">*</span></label>
              <div class="input-group">
                <input type="text" name="" id="" class="input-form" placeholder="会社名を入力してください" v-model="detailCompany.company_name" :class="{error: !$v.detailCompany.company_name.required && invalid}" @input="$v.detailCompany.company_name.$touch()">
                <small v-if="!$v.detailCompany.company_name.required && invalid" class="text-input error">{{message.COMPANY_NAME_REQUIRED}}</small>
              </div>
            </div>
            <label for="" class="admin-vendor-label">事業内容</label>
            <input type="text" name="" id="" class="input-form mb-20" placeholder="事業内容を入力してください" v-model="detailCompany.business_content">
            <b-row>
              <b-col cols="12" lg="6">
                <div class="form-group">
                  <div class="input-group">
                    <label for="" class="admin-vendor-label">従業員数</label>
                    <input type="text" name="" id="" maxlength="11" class="input-form" placeholder="従業員数を入力してください" v-model="detailCompany.number_employees" :class="{error: !$v.detailCompany.number_employees.numeric && invalid}">
                    <small v-if="!$v.detailCompany.number_employees.numeric && invalid" class="text-input error">{{message.NUMBER_EMPLOYEE_FORMAT}}</small>
                  </div>
                </div>
              </b-col>
              <b-col cols="12" lg="6">
                <div class="form-group">
                  <div class="input-group">
                    <label for="" class="admin-vendor-label">資本金</label>
                    <input type="text" name="" id="" maxlength="10" class="input-form" placeholder="資本金を入力してください" v-model="detailCompany.capital">
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="6">
                <div class="form-group">
                  <label for="" class="admin-vendor-label">代表者名<span class="required">*</span></label>
                  <div class="input-group">
                    <input type="text" name="" id="" class="input-form" placeholder="代表者名を入力してください" v-model="detailCompany.representative_name" :class="{error: !$v.detailCompany.representative_name.required && invalid}" @input="$v.detailCompany.representative_name.$touch()">
                    <small v-if="!$v.detailCompany.representative_name.required && invalid" class="text-input error">{{message.REPRESENTATIVE_NAME_REQUIRED}}</small>
                  </div>
                </div>
              </b-col>
              <b-col cols="12" lg="6">
                <div class="form-group">
                  <label for="" class="admin-vendor-label">代表電話番号<span class="required">*</span></label>
                  <div class="input-group">
                    <input type="text" name="" id="" class="input-form" placeholder="代表電話番号を入力してください" v-model="detailCompany.representative_phone" :class="phoneError()" @input="$v.detailCompany.representative_phone.$touch()">
                    <small v-if="!$v.detailCompany.representative_phone.required && invalid" class="text-input error">{{message.REPRESENTATIVE_PHONE_REQUIRED}}</small>
                    <small v-if="!$v.detailCompany.representative_phone.valid && invalid && $v.detailCompany.representative_phone.required" class="text-input error">{{message.PHONE_FORMAT}}</small>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="6">
                <div class="form-group">
                  <label for="" class="admin-vendor-label">メールアドレス<span class="required">*</span></label>
                  <div class="input-group">
                    <input type="text" name="" id="" class="input-form" placeholder="メールアドレスを入力してください" v-model="detailCompany.representative_email" :class="emailFormat()" @input="$v.detailCompany.representative_email.$touch()">
                    <small v-if="!$v.detailCompany.representative_email.required && invalid" class="text-input error">{{message.EMAIL_REQUIRED}}</small>
                    <small v-if="!$v.detailCompany.representative_email.valid && invalid && $v.detailCompany.representative_email.required" class="text-input error">{{message.EMAIL_FORMAT}}</small>
                    <small v-if="errorVendorMessage.representative_email && serveError" class="text-input error">{{emailError(errorVendorMessage.representative_email[0])}}</small>
                  </div>
                </div>
              </b-col>
              <b-col cols="12" lg="6">
                <label for="" class="admin-vendor-label">ホームページ</label>
                <input type="text" name="" id="" class="input-form mb-20" placeholder="ホームページを入力してください" v-model="detailCompany.homepage">
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="6">
                <div class="filter-wrapper">
                  <b-form inline class="float-md-left mt-2">
                    <b-form-checkbox
                      stacked
                      class="mts-2 ml-2"
                      v-model="detailCompany.parent_company"
                      :value="1"
                      :unchecked-value="0"
                    > 登録代表会社</b-form-checkbox>
                  </b-form>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="!detailCompany.parent_company" class="mt-3">
              <b-col cols="12" lg="6">
                <div class="form-group">
                <label class="label-form">会社</label>
                <div class="input-group">
                  <b-form-select  class="select select-dropdown input-form" v-model="detailCompany.company_uuid">
                    <b-form-select-option v-for="company in companies" :key="company.id" :value="company.id">{{company.company_name}}</b-form-select-option>
                  </b-form-select>
                </div>
              </div>
              </b-col>
            </b-row>
            <div class="w-100 mb-30 mt-30">
              <div class="d-flex mypage__btnGroup justify-content-center btn-reverse">
                <button class="btn btn-secondary btn-rounder mr-30 btn-basic" type="button" @click.prevent="goBack">キャンセル</button>
                <button class="btn btn-primary btn-rounder btn-basic" type="button" @click="editCompany">更新</button>
              </div>
            </div>
          </form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from '@/components/share/Header'
import Breadcrumb from '@/components/share/Breadcrumb'
import SidebarVendor from '@/views/Admin/Company/SidebarEdit'
import { numeric, required } from 'vuelidate/lib/validators'
import {MESSAGE} from '@/utils/errorjapanese'
import {mapState} from 'vuex'
import errorMessage from '@/utils/errormessage'
import Tabs from '@/components/Admin/Company/Tabs'
export default {
  name: 'admin_edit_vendor_view',
  components: {
    Header,
    Breadcrumb,
    SidebarVendor,
    Tabs
  },
  data () {
    return {
      invalid: false,
      message: MESSAGE,
      serveError: false,
      tabIndex: 1,
      zip_code_1: '',
      zip_code_2: '',
      location: '',
      searchResults: [],
      service: null,
      paginations: {
        page_index: 1,
        sortBy: 'created_at',
        sortOrder: 'desc',
        searchQuery: '',
        typingTimer: null,
        isTyping: false,
        displayParentCompanyOnly: 1
      }
    }
  },
  validations: {
    zip_code_1: {
      numeric,
      valid (zipCode) {
        if (zipCode || this.zip_code_2) {
          const validate = /^[0-9-.+]{3}$/i.test(zipCode)
          return validate
        }
        return true
      }
    },
    zip_code_2: {
      numeric,
      valid (zipCode) {
        if (zipCode || this.zip_code_1) {
          const validate = /^[0-9-.+]{4}$/i.test(zipCode)
          return validate
        }
        return true
      }
    },
    detailCompany: {
      company_name: {
        required
      },
      representative_name: {
        required
      },
      representative_phone: {
        required,
        valid (phone) {
          const validate = /^[0-9-.+]{3,20}$/i.test(phone)
          return validate
        }
      },
      representative_email: {
        required,
        valid (email) {
          const validate = /^[[a-zA-Z][a-zA-Z0-9_.-]{1,32}@[a-z0-9_-]{2,}(\.[a-z0-9]{2,}){1,}$/.test(email)
          return validate
        }
      },
      number_employees: {
        numeric
      }
    }
  },
  watch: {
    'detailCompany.representative_email' () {
      this.$store.commit('adminCompany/CHANGE_ERROR', '')
    },
    'detailCompany' () {
      if (this.detailCompany.zip_code) {
        this.zip_code_1 = this.detailCompany.zip_code.slice(0, 3)
        this.zip_code_2 = this.detailCompany.zip_code.slice(3, 7)
      }
    },
    'zip_code_1' (value) {
      this.detailCompany.zip_code = value + this.zip_code_2
      let postalCode = require('japan-postal-code')
      let me = this
      postalCode.get(me.detailCompany.zip_code, function (add) {
        me.detailCompany.address = add.prefecture + add.city + add.area + add.street
      })
    },
    'zip_code_2' (value) {
      this.detailCompany.zip_code = this.zip_code_1 + value
      let postalCode = require('japan-postal-code')
      let me = this
      postalCode.get(me.detailCompany.zip_code, function (add) {
        me.detailCompany.address = add.prefecture + add.city + add.area + add.street
      })
    },
    'detailCompany.address' (newValue) {
      if (newValue) {
        this.service.getPlacePredictions({
          input: this.detailCompany.address
        }, this.displaySuggestions)
      }
      if (newValue === '') {
        this.searchResults = []
      }
    }
  },
  methods: {
    zipCodeHeadFormat () {
      if (this.zip_code_1 || this.zip_code_2) {
        return ((!this.$v.zip_code_1.valid || !this.$v.zip_code_1.numeric)) ? 'error' : ''
      }
      return ''
    },
    zipCodeTailFormat () {
      if (this.zip_code_1 || this.zip_code_2) {
        return (((!this.$v.zip_code_2.valid || !this.$v.zip_code_2.numeric))) ? 'error' : ''
      }
      return ''
    },
    MapsInit () {
      this.service = new window.google.maps.places.AutocompleteService()
    },
    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = []
        return
      }
      this.searchResults = predictions.map(prediction => prediction.description)
    },
    emailFormat () {
      return ((!this.$v.detailCompany.representative_email.valid || !this.$v.detailCompany.representative_email.required) && this.invalid) || this.errorVendorMessage.representative_email ? 'error' : ''
    },
    phoneError () {
      return (!this.$v.detailCompany.representative_phone.required || !this.$v.detailCompany.representative_phone.valid) && this.invalid ? 'error' : ''
    },
    editCompany (e) {
      e.preventDefault()
      this.serveError = true
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      const formData = new FormData()
      if (this.detailCompany.logo !== this.editLogoCompany.logo) {
        formData.append('logo', this.detailCompany.logo)
      }
      formData.append('company_name', this.detailCompany.company_name)
      formData.append('representative_name', this.detailCompany.representative_name)
      formData.append('representative_phone', this.detailCompany.representative_phone)
      formData.append('representative_email', this.detailCompany.representative_email)
      if (this.detailCompany.address) {
        formData.append('address', this.detailCompany.address)
      }
      if (this.detailCompany.number_employees) {
        formData.append('number_employees', this.detailCompany.number_employees)
      }
      if (this.detailCompany.capital) {
        formData.append('capital', this.detailCompany.capital)
      }
      if (this.detailCompany.zip_code) {
        formData.append('zip_code', this.detailCompany.zip_code)
      }
      if (this.detailCompany.homepage) {
        formData.append('homepage', this.detailCompany.homepage)
      }
      if (this.detailCompany.parent_company) {
        formData.append('parent_company', this.detailCompany.parent_company)
      } else if (!this.detailCompany.parent_company && this.detailCompany.company_uuid) {
        formData.append('parent_company', this.detailCompany.parent_company)
        formData.append('company_uuid', this.detailCompany.company_uuid)
      }

      if (this.detailCompany.business_content) {
        formData.append('business_content', this.detailCompany.business_content)
      }
      formData.append('_method', 'put')
      this.$store.dispatch('adminCompany/updateCompany', {id: this.detailCompany.id, formData: formData})
    },
    formatCapital (value) {
      value.value = value.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },
    goBack () {
      this.serveError = false
      this.$router.push(`/admin/companies/${this.detailCompany.id}/infor`)
    },
    emailError (value) {
      return errorMessage.errorEmail(value)
    }
  },
  mounted () {
    this.$store.dispatch('adminCompany/detailCompany', this.$route.params.id)
    this.$store.dispatch('adminCompany/getCompany', this.paginations)
    this.MapsInit()
    if (this.vendor && this.vendor.zip_code) {
      this.zip_code_1 = this.detailCompany.zip_code.slice(0, 3)
      this.zip_code_2 = this.detailCompany.zip_code.slice(3, 7)
    }
  },
  computed: {
    ...mapState({
      detailCompany: state => state.adminCompany.detailCompany,
      editLogoCompany: state => state.adminCompany.editLogoCompany,
      errorVendorMessage: state => state.adminCompany.errorVendorMessage,
      companies: state => state.adminCompany.companies
    })
  }
}
</script>
<style scoped lang="scss">
  @import '@/assets/stylesheet/admin/vendor.scss';
  @media screen and (max-width: 991px) {
    .mt-20 {
      margin-top: 20px;
    }
    .admin-vendor-btnGroup {
      flex-direction: row-reverse;
    }
  }
  .form-group {
    margin-bottom: 0;
  }
  .btn-space {
    margin-top: 10px;
    margin-bottom: 33px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/Edit.vue